module.exports = {
  // JCRing成员页 阿拉伯语
  JCRing_member: {
    index1: "صحة الأعضاء",
    index2: "مجموعة الصحة",
    index3: "عضو",
    index4: "إضافة مجموعة",
    index5: "المجموعات المنضمة إليها",
index6: "إعدادات التنبيه",
    index7: "دع الأشخاص الذين يهتمون بصحتك يهتمون بك أكثر",
    index8: "لم يتم الانضمام إلى مجموعة حتى الآن",
    index9: "مركز الرسائل",
    index10: "ادعُ للانضمام عبر /الهاتف/ البريد الإلكتروني/ رمز QR/ Wechat",

    //创建群组
    addgroup1: "اسم المجموعة",
    addgroup2: "نوع المجموعة",
    addgroup3: "يرجى إدخال اسم المجموعة",
    addgroup4: "مجموعة الأسرة",
    addgroup5: "مجموعة الشركة",
    addgroup6: "مجموعات أخرى",
    addgroup7: "مجموعة طبية",
    addgroup8: "مجموعة المدرسة",
    addgroup9: "تأكيد",
    addgroup10: "إلغاء",
    addgroup11: "إنشاء الآن",
    addgroup12: "اسم المجموعة موجود بالفعل",

    //成员列表
    memberlist1: "قائمة الأعضاء",
    memberlist2: "يوجد",
    memberlist3: "غير طبيعي",
    memberlist4: "طبيعي",
    memberlist5: "إضافة عضو",
    memberlist6: "حل",
    memberlist7: "لا يوجد أعضاء حاليًا",
    memberlist8: "جار التحميل...",
    memberlist9: "هل تريد حل هذه المجموعة؟？",
    memberlist10: "تم الحل بنجاح",
    memberlist11: "تم الحفظ بنجاح",
    memberlist12: "تعديل معلومات المجموعة",
    memberlist13: "حل المجموعة",
    memberlist14: "لمحة عامة عن الصحة",
    memberlist15: "طبيعي",
    memberlist16: "غير طبيعي",
    memberlist17: "انقر لعرض",
    memberlist18: "لا توجد بيانات أمس",
    memberlist19: "أمس",
    memberlist20: "تم الإرسال",
    memberlist21: "دعوة مجموعة، في انتظار التأكيد",

    //修改成员
    updatemember1:"الصورة الرمزية",
    updatemember2: "تغيير",
    updatemember3: "الاسم الأصلي",
    updatemember4: "تعديل الاسم",

    //健康数据
healthdata1: "بيانات صحية",
healthdata2: "بيانات صحية",
healthdata3: "الأحد",
healthdata4: "الاثنين",
healthdata5: "الثلاثاء",
healthdata6: "الأربعاء",
healthdata7: "الخميس",
healthdata8: "الجمعة",
healthdata9: "السبت",
healthdata10: "معدل ضربات القلب",
healthdata11: "HRV",
healthdata12: "ضغط الدم الانقباضي",
healthdata13: "ضغط الدم الانبساطي",
healthdata14: "تغير درجة الحرارة",
healthdata15: "تشبع الأكسجين في الدم",
healthdata16: "النوم",
healthdata17: "الإجهاد",
healthdata18: "الكوليسترول",
healthdata19: "الدهون الثلاثية",
healthdata20: "كوليسترول البروتين الدهني منخفض الكثافة",
healthdata21: "كوليسترول البروتين الدهني عالي الكثافة",
healthdata22: "سكر الدم",
healthdata23: "قبل الوجبة",
healthdata24: "بعد الوجبة",
healthdata25: "Vo2Max",
healthdata26: "التنفس",
healthdata27: "خطوات",
healthdata28: "خطوة",
healthdata29: "السعرات الحرارية",
healthdata30: "Kcal",
healthdata31: "المسافة",
healthdata32: "KM",
healthdata33: "السرعة",
healthdata35: "S/KM",
healthdata36: "Min",
healthdata37: "جاري تحميل البيانات الصحية",
healthdata38: "بيانات التمرين",
healthdata39: "تنبيه",
healthdata40: "غير مرخص",
healthdata41: "تعديل معلومات الأعضاء",
healthdata42: "حذف العضو",
healthdata43: "Email:",
healthdata44: "الجوال:",
healthdata45: "هل تريد حذف هذا العضو؟",
healthdata46: "لا يمكن عرض التواريخ المستقبلية",
healthdata47: "اليوم",

    //邀请成员,
addmember1: "دعوة عضو",
addmember2: "إضافة حساب العضو",
addmember4: "من خلال 'حساب العضو'، يمكنك عرض بيانات صحة الأعضاء وتعيين نطاقات بيانات التنبيه لمراقبة صحة الأعضاء بشكل أفضل",
addmember5: "تعرف على المزيد",
addmember6: "أعضاء مجموعة الصحة",
addmember7: "دعوة",
addmember8: "انضم",
addmember9: "دعوة عبر رمز الاستجابة السريعة",
addmember10: "دعوة عبر WeChat",
addmember11: "دعوة للانضمام إلى المجموعة عبر رمز الاستجابة السريعة",
addmember12: "دعوة للانضمام إلى المجموعة عبر WeChat",
addmember13: "دعوة عبر رقم الهاتف/البريد الإلكتروني",
addmember14: "دعوة للانضمام إلى المجموعة عبر رقم الهاتف/البريد الإلكتروني",
addmember15: "دعوة الأعضاء للانضمام لفهم حالتهم الصحية",
addmember16: "إرسال دعوة",
addmember17: "تم الإرسال",
addmember18: "في انتظار التأكيد",
addmember19: "لقد انضممت",
addmember20: "شارك الآن",
addmember21: "حفظ الصورة",
addmember22: "لقد رفضت",
addmember23: "لقد خرجت",
addmember24: "الطرف الآخر خرج",
addmember25: "الطرف الآخر رفض",
addmember26: "الطرف الآخر انضم",
addmember27: "طرق أخرى للإضافة",

    // 群组二维码,
code1: "رمز الاستجابة السريعة للمجموعة",
code2: "Grupa zarządzania zdrowiem",
code3: "الرمز الاستجابي صالح لمدة 5 دقائق، يرجى استخدامه في الوقت المناسب",

    //群组邀请,
invide1: "دعوة المجموعة",
invide2: "صحة الأعضاء",
invide3: "دعوتك للانضمام إلى المجموعة...",
invide4: "انضم لهذه المجموعة",
invide5: "لسلامة بياناتك، نوصيك بالتحقق من معلومات المجموعة قبل الانضمام",
invide6: "عند الانضمام إلى المجموعة، ستمنح المشاهدين إذنًا لعرض بيانات صحتك",

    //分享健康数渶设置,
sethealthdata1: "إعدادات البيانات الصحية",
sethealthdata2: "تأكيد",
sethealthdata3: "يرجى تعيين لقب",
sethealthdata4: "السماح للجميع",
sethealthdata5: "تعيين لقب",
sethealthdata6: "حفظ",
sethealthdata7: "يرجى إدخال",
sethealthdata8: "يرجى تحميل تنسيق الصورة",
sethealthdata9: "يرجى تعيين لقب وصورة رمزية",
sethealthdata10: "يرجى تعيين صورة رمزية",
sethealthdata11: "طول اللقب هو 1-8 أحرف",

    // 设置数据区间,
setscope1: "نطاق الحدود العليا والسفلى لمعدل ضربات القلب",
setscope2: "نطاق الحدود العليا والسفلى لدرجة الحرارة",
setscope3: "نطاق الحدود العليا والسفلى لفترة النوم",
setscope4: "نطاق الحدود العليا والسفلى لنبضات الجنين",
setscope5: "سكر الدم قبل الأكل",
setscope6: "سكر الدم بعد الأكل",
setscope7: "نطاق الحدود العليا والسفلى لتشبع الأكسجين",
setscope8: "حمض اليوريك للرجال",
setscope9: "حمض اليوريك للنساء",
setscope10: "ضغط الانقباضي",
setscope11: "ضغط الانبساطي",
setscope12: "الحد الأعلى",
setscope13: "الحد الأدنى",
setscope14: "إعدادات التحذير",
setscope15: "تم الضبط بنجاح",
setscope16: "الحد الأعلى",
setscope17: "الحد الأدنى",
setscope18: "تحذير",

    //下载页,
onload1: "انقر",
onload2: "انضمام إلى مجموعة صحية",
onload3: "افتح بالمتصفح",
onload4: "فهمت",
onload5: "صحة يوهونج، استمتع بالصحة كل يوم",
onload6: "تحميل مجاني من متجر التطبيقات",
onload7: "تحميل مجاني",
onload8: "انتهت صلاحية الرابط",
onload9: "انتهت صلاحية الرمز الشريطي",
onload10: "تم الانضمام بنجاح",

    // （消息中心）待处理,
pending1: "موافق",
pending2: "رفض",
pending3: "إعادة إرسال الدعوة",
pending4: "لا توجد بيانات متاحة حاليا",
pending5: "تم إرسال الدعوة، في انتظار موافقة المستخدم",
pending6: "تأكيد",
pending7: "الخروج",

guide1: "بعد الدخول إلى صحة الأعضاء، يجب إنشاء نوع المجموعة المناسب أولاً.",
guide2: "بعد إنشاء المجموعة، يمكنك الدخول إلى المجموعة لعرض نظرة عامة على صحة المستخدم ودعوة أعضاء جدد للانضمام إلى المجموعة.",
guide3: "يمكنك دعوة أعضاء جدد إلى المجموعة عبر مسح الرمز، واتساب، رقم الهاتف / البريد الإلكتروني، وغيرها. بعد انضمام الأعضاء الجدد إلى المجموعة، يمكنك عرض ديناميكية صحتهم يوميًا.",
guide4: "انقر لعرض نظرة عامة على الصحة، يمكنك عرض بيانات الصحة للأعضاء وتحديد ما إذا كانت طبيعية أو غير طبيعية.",
guide5: "الخطوة التالية",
guide6: "انجز",
guide7: "تجاوز القيمة التحذيرية",

invite1: "دعوة عبر رقم الهاتف / البريد الإلكتروني",
invite2: "يرجى إدخال الحساب",
invite3: "يرجى إدخال رقم الهاتف",
invite4: "يرجى إدخال البريد الإلكتروني",
invite5: "أدخل رقم هاتف صحيح",
invite6: "أدخل عنوان بريد إلكتروني صحيح",
invite7: "تم الانضمام إلى المجموعة",
invite8: "المستخدم غير موجود",
invite9: "يرجى تحديد البلد أو المنطقة",
invite10: "يرجى إدخال كلمة البحث",
invite11: "تأكيد المستخدم",
invite12: "دعوتهم",
invite13: "يرجى الاختيار",
  }
};



// WEBPACK FOOTER //
// ./src/lang/ar.js